import {
  Component
} from "@angular/core";
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import {
  IonicPage,
  NavController,
  NavParams,
  Platform,
  AlertController,
  ActionSheetController,
  ToastController,
  LoadingController,
  ModalController,
  ViewController
} from "ionic-angular";
import { AuthProvider } from "../../providers/auth/auth";
import { DatabaseProvider } from "../../providers/database/database";
import { PatientsPage } from "../patients/patients";
import { PatientBatchPage } from "../patient-batch/patient-batch";
import { OrdersPage } from "../orders/orders";
import { Storage } from '@ionic/storage';
import _ from "lodash";
import moment from "moment";

@IonicPage()
@Component({
  selector: "page-patient-add",
  templateUrl: "patient-add.html"
})
export class PatientAddPage {

  public continuousMode: boolean = false;
  patientForm: FormGroup;
  submitAttempt: boolean = false;
  patient: any = {};
  patientdata: any = {};
  ismobile = false;
  differentShipAddress: boolean = false;
  scannerActive: string = "barcode";
  lastImage: string;
  public error: string;
  public isExisting: boolean = false;
  public patientType: string = "New Patient";
  clinic_name: string = null;
  clinic_id: string = null;
  groups: any;
  rx_id: string = null;

  // Patient Form
  first_name: FormControl;
  last_name: FormControl;
  healthcard: FormControl;
  dob: FormControl;
  gender: FormControl;
  email: FormControl;
  phone_number: FormControl;
  address: FormControl;
  address2: FormControl;
  city: FormControl;
  province: FormControl;
  postal_code: FormControl;
  group: FormControl;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public toastCtrl: ToastController,
    public platform: Platform,
    public loadingCtrl: LoadingController,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public viewCtrl: ViewController,
    private storage: Storage,
  ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      database.getGroups(this.clinic_id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        })
        .subscribe( async (groups) => {
          this.groups = groups;
        })
    });

    this.first_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.last_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.gender = new FormControl("", Validators.required);
    this.healthcard = new FormControl("", Validators.required);
    this.dob = new FormControl("", Validators.required);
    this.email = new FormControl(
      "",
      Validators.compose([
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$")
      ])
    );
    this.phone_number = new FormControl("");

    this.address = new FormControl("", Validators.required);
    this.address2 = new FormControl("");
    this.city = new FormControl("", Validators.required);
    this.province = new FormControl("", Validators.required);
    this.postal_code = new FormControl("", Validators.required);
    this.group = new FormControl("");

    this.patient = formBuilder.group({
      first_name: this.first_name,
      last_name: this.last_name,
      healthcard: this.healthcard,
      dob: this.dob,
      gender: this.gender,
      email: this.email,
      phone_number: this.phone_number,
      address: this.address,
      address2: this.address2,
      city: this.city,
      province: this.province,
      postal_code: this.postal_code,
      group: this.group,
    });

    if (this.navParams.get("patient")) {
      this.patientdata = this.navParams.get("patient");
      this.patient.patchValue(this.patientdata);
      console.log(`Date of birth - ${this.patientdata.dob}`);
      const newdob = moment(`${this.patientdata.dob}T12:00:00Z`).add(1,'day').utc().format("YYYY-MM-DD");
      console.log(`Parse dob - ${newdob}`);
      this.patient.controls['dob'].setValue(newdob);
      this.isExisting = true;
      this.patientType = "Edit " + this.patientdata.first_name;
      if(this.navParams.get("rxId"))  {
        this.rx_id = this.navParams.get("rxId");
      }
      console.log('Patient Data: ', this.patientdata);
    } else {
      this.province.setValue('ON');
    }

    if (platform.is("ios") || platform.is("android")) {
      this.ismobile = true;
    }
  }

  async savePatient(addPrescription: boolean) {
    let confirm = this.alertCtrl.create({
      title: "Save This Patient?",
      message: "Are you sure you want to save this patient?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: async () => {
            this.patientdata = this.patient.value;
            this.patientdata["full_name"] = this.patientdata["first_name"].trim() + ' ' + this.patientdata["last_name"].trim();
            this.patientdata["dob"] = moment(this.patientdata["dob"]).format("YYYY-MM-DD");
            this.database.addPatient(this.clinic_id, this.patientdata)
              .then((patient_id) => {
                this.patientdata.id = patient_id;
                const callback = this.navParams.get("addCallback");
                return callback(this.patientdata);
              })
              .then(() => {
                if (addPrescription) {
                  this.navCtrl.push(PatientBatchPage, {'patientdata': this.patientdata, 'isnewpatient': true});
                } else {
                  this.navCtrl.pop()
                }
              })
              .catch(err => {
                const toast = this.toastCtrl.create({
                  message: err,
                  duration: 3000
                });
                toast.present();
              });
          }
        }
      ]
    });
    confirm.present();
  }

  updatePatient() {
    let confirm = this.alertCtrl.create({
      title: "Update This Patient?",
      message: "Are you sure you want to update this patient information?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            let tempid = this.patientdata.id;
            let old_group = this.patientdata.group;
            this.patientdata = this.patient.value;
            this.patientdata["id"] = tempid;
            this.patientdata["old_group"] = old_group ? old_group : "None";
            this.patientdata["full_name"] = this.patientdata["first_name"] + ' ' + this.patientdata["last_name"];
            this.patientdata["dob"] = moment(this.patientdata["dob"]).format("YYYY-MM-DD");
            this.database.updatePatient(this.clinic_id, this.patientdata).then(() => {
              console.log('patient info updated;');
              if (this.rx_id)  {
                this.database.updatePrescriptionPatientInfo(this.rx_id, this.patientdata).then(() => {
                  // console.log('order info updated');
                  // const callback = this.navParams.get("editCallback");
                  // callback(this.patientdata).then(() => 
                  this.navCtrl.pop()
                });
              } else {            
                  const callback = this.navParams.get("editCallback");
                  callback(this.patientdata).then(() => this.navCtrl.pop())
              }
            }).catch(err => {
                const toast = this.toastCtrl.create({
                  message:
                    "There was an error updating this patient.  If you changed the email address, please make sure that it has not been used before for another patient.",
                  duration: 3000
                });
                toast.present();
              });
          }
        }
      ]
    });
    confirm.present();
  }

  async updateCurrentOrder() {

  }

  updatePatientFromBarcode(ev) {
    // Get First Name from DL
    this.patientdata["first_name"] = ev["first_name"];

    // Get Last Name from DL
    this.patientdata["last_name"] = ev["last_name"];

    // Get DOB from DL
    this.patientdata["dob"] = ev["dob"];

    // Get Gender from DL
    this.patientdata["gender"] = ev["gender"];

    this.patientdata["address"] = ev["address"];

    this.patientdata["city"] = ev["city"];
    this.patientdata["province"] = ev["province"];
    this.patientdata["postal_code"] = ev["postal_code"];

    this.patient.patchValue(this.patientdata);
  }

  bestTime = ["Morning", "Afternoon", "Evening"];

  provinces = [
    // { short: "AB", name: "Alberta", country: "CA" },
    // { short: "BC", name: "British Columbia", country: "CA" },
    // { short: "MB", name: "Manitoba", country: "CA" },
    // { short: "NB", name: "New Brunswick", country: "CA" },
    {
      short: "NL",
      name: "Newfoundland and Labrador",
      country: "CA",
      alt: ["Newfoundland", "Labrador"]
    },
    // { short: "NS", name: "Nova Scotia", country: "CA" },
    // { short: "NU", name: "Nunavut", country: "CA" },
    // { short: "NT", name: "Northwest Territories", country: "CA" },
    { short: "ON", name: "Ontario", country: "CA" },
    // { short: "PE", name: "Prince Edward Island", country: "CA" },
     { short: "QC", name: "Quebec", country: "CA" }
    // { short: "SK", name: "Saskatchewan", country: "CA" },
    // { short: "YT", name: "Yukon", country: "CA" }
  ];

  compareGroups( group1, group2 ) : boolean {
    return group1.id === group2.id;
  }

  logger() {
    console.log(this.dob);
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-add/patient-add.ts